import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../../muiComponents/Icon';
import '../../stylesheets/stylesLayout/lateralMenu.scss';
import useTranslate from '../../customHooks/useTranslate';

const LateralMenuBasic = ({ list = [] }) => {
    const translate = useTranslate();
    const [isOpenMenu, setIsOpenMenu] = useState(true);

    return (
        <nav
            className={`menu-list__container ${
                isOpenMenu ? '--expanded' : '--collapsed'
            }`}
        >
            <ul className='menu-list'>
                {list.map((item, i) => {
                    const { link, text, icon } = item;

                    return (
                        <li key={i} className='menu__item'>
                            <NavLink to={link} className='menu-item__link'>
                                <Icon
                                    iconName={icon}
                                    className='menu-item__icon'
                                    fontSize='medium'
                                />
                                <span className='menu-item__text'>
                                    {translate(text)}
                                </span>
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
            <Icon
                iconName='KeyboardArrowLeft'
                className={`menu__colapse-icon ${
                    isOpenMenu ? '--expanded' : '--collapsed'
                }`}
                onClick={() => setIsOpenMenu(prev => !prev)}
            />
        </nav>
    );
};

export default LateralMenuBasic;
